export enum GenerateInvoiceValidationErrorType {
	CompanyMissingCategoryCode = 1,
	CompanyMissingAddress = 2,
	CompanyMissingZipCode = 3,
	CompanyWrongZipCodeFormat = 4,
	InvoiceGroupMissingAddress = 5,
	InvoiceGroupMissingZipCode = 6,
	InvoiceGroupWrongZipCodeFormat = 7,
	InvoiceGroupMissingContact = 8,
	InvoiceGroupMissingMailTo = 9,
	CompanyMissingRoleContacts = 10,
	CompanyMissingMainContact = 11,
	CompanyMissingMainContactEmail = 12,
	ReferralContactMissingContact = 13,
	ReferralContactMissingEmail = 14,
	CompanyContractMissingTerm = 15,
	DuplicatePLAgreement = 16,
	FacilityMissingInvoicingGroup = 17,
}
